import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import dateFnsFormat from 'date-fns/format'
import 'react-day-picker/lib/style.css'

import FormError from 'components/FormError/FormError'
import { isDate, notAfterThreeMonth, required } from 'services/validation'
import { Error } from './DayPickerStyle'

const DayPicker = ({
  className,
  locale,
  lang,
  dateFormat = 'dd-MM-yyyy',
  customDayPickerProps,
  error,
  dispatch,
  invalid,
  value,
  ...otherProps
}) => {
  const [field, setField] = useState(null)
  const [state, setState] = useState({
    isEmpty: false,
    errorRequired: null,
    errorUnauthorizedDate: null,
    errorValidDate: null,
  })
  const errorMsg =
    state.errorRequired || state.errorUnauthorizedDate || state.errorValidDate

  const handleDayChange = dayPickerInput => {
    const date = dayPickerInput || field.input.value
    const errorRequired = required(date)
    const errorValidDate = !dayPickerInput && isDate(date)
    const errorUnauthorizedDate = dayPickerInput
      ? !errorValidDate && notAfterThreeMonth(date, true)
      : !errorValidDate && notAfterThreeMonth(date)

    setState({
      ...state,
      errorRequired,
      errorUnauthorizedDate,
      errorValidDate,
    })
  }

  return (
    <>
      <DayPickerInput
        ref={input => setField(input)}
        value={value}
        locale={lang}
        format={dateFormat}
        inputProps={{ ...otherProps }}
        formatDate={date => dateFnsFormat(date, dateFormat)}
        placeholder={`${dateFormat}`}
        classNames={{
          container: classnames('DayPickerInput', className),
          overlay: 'DayPickerInput-Overlay',
          overlayWrapper: 'DayPickerInput-OverlayWrapper',
        }}
        dayPickerProps={customDayPickerProps}
        onDayChange={date => handleDayChange(date)}
      />
      {errorMsg !== null && (
        <Error>
          <FormError error={errorMsg} />
        </Error>
      )}
    </>
  )
}

DayPicker.propTypes = {
  className: PropTypes.string,
  lang: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
  error: PropTypes.shape({
    id: PropTypes.string,
    values: PropTypes.object,
  }),
  customDayPickerProps: PropTypes.shape({
    firstDayOfWeek: PropTypes.number,
    months: PropTypes.array,
    weekdaysLong: PropTypes.array,
    weekdaysShort: PropTypes.array,
    disabledDays: PropTypes.array,
  }),
}

export default DayPicker
